/**
 * Etykieta numeru sprawy CEEB budynku (`buildings.ceeb_id`), świadoma roku.
 *
 * `ceeb_id` to numer sprawy NAJNOWSZEGO protokołu, jaki nocny import znalazł w CEEB — np.
 * „2783569/2025". Bronek (2026-10-15) czytał go jako „pracujemy na protokole 2025", a my nigdy
 * nie edytujemy protokołów z lat poprzednich: przy „Wyślij do CEEB" powstaje NOWY protokół
 * bieżącego roku (model create-first). Gdy rok sprawy < bieżący, etykieta mówi to wprost.
 *
 * Lustro: `mobile/src/utils/ceebProtocolLabel.ts` (to samo zachowanie, te same testy).
 */

/** Rok z końcówki numeru sprawy („…/2025" → 2025); brak końcówki → null. */
export function ceebCaseYear(ceebId: string | null | undefined): number | null {
  const m = /(\d{4})$/.exec((ceebId ?? '').trim());
  return m ? Number(m[1]) : null;
}

/** Czy rok (sprawy/protokołu) jest wcześniejszy niż bieżący. Nieznany rok → false. */
export function isBeforeCurrentYear(year: number | null | undefined, now: Date = new Date()): boolean {
  return year != null && year < now.getFullYear();
}

/**
 * Krótki dopisek do ciasnych miejsc (wiersz listy): „zeszły rok" / „2024 r." — albo null,
 * gdy sprawa jest z bieżącego roku (lub numer nie ma roku) i nic nie dopisujemy.
 */
export function ceebProtocolShortNote(ceebId: string | null | undefined, now: Date = new Date()): string | null {
  const year = ceebCaseYear(ceebId);
  if (!isBeforeCurrentYear(year, now)) return null;
  return year === now.getFullYear() - 1 ? 'zeszły rok' : `${year} r.`;
}

/**
 * Pełna etykieta (nagłówki, tooltipy). Sprawa z poprzedniego roku →
 * „Ostatni protokół w CEEB: 2783569/2025 — nowy (2026) powstanie przy wysyłce";
 * w przeciwnym razie dotychczasowe „CEEB: 2783569/2026".
 */
export function ceebProtocolLabel(ceebId: string, now: Date = new Date()): string {
  if (!isBeforeCurrentYear(ceebCaseYear(ceebId), now)) return `CEEB: ${ceebId}`;
  return `Ostatni protokół w CEEB: ${ceebId} — nowy (${now.getFullYear()}) powstanie przy wysyłce`;
}
